module.exports = __webpack_public_path__ + "static/media/ca.ea6532d7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ca.svg
// module id = 829
// module chunks = 0